var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14.8889C16.2295 14.8889 14.3889 16.7295 14.3889 19C14.3889 21.2705 16.2295 23.1111 18.5 23.1111C20.7705 23.1111 22.6111 21.2705 22.6111 19C22.6111 16.7295 20.7705 14.8889 18.5 14.8889Z",
    fill: "#044D76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19C0 8.78273 8.28273 0.5 18.5 0.5C28.7173 0.5 37 8.78273 37 19C37 29.2173 28.7173 37.5 18.5 37.5C8.28273 37.5 0 29.2173 0 19ZM8.22222 19C8.22222 13.3237 12.8237 8.72222 18.5 8.72222C24.1763 8.72222 28.7778 13.3237 28.7778 19C28.7778 24.6763 24.1763 29.2778 18.5 29.2778C12.8237 29.2778 8.22222 24.6763 8.22222 19Z",
    fill: "#044D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileapp);
export default __webpack_public_path__ + "static/media/mobile app.5fd0c1e9f834fa32105750f8a18c772a.svg";
export { ForwardRef as ReactComponent };